import $ from 'jquery';

function content() {
	function stickyPanel () {
		var $main = $('.content__panel'),
		$stickyPanel = $('.content__sticky'),
		$mainContent = $('.content__main '),
		$offsetElm = $('.page__header'),
		minWindowWidth = 1024,
		modifierСlasses = {
			stickyWrapper: 'content__panel_type_sticky',
			sticky: {
				top: 'content__sticky_top',
				bottom: 'content__sticky_bottom'
			}
		};

		if($main && $stickyPanel.length && $mainContent.length) {
			var headerOffset = $offsetElm.outerHeight() || 0,
			stickyPanelWidth = $stickyPanel.closest().width();

			if($(window).width() >= minWindowWidth && $main && $stickyPanel.outerHeight() + headerOffset < $main.outerHeight()) {
				var topOffset = $(window).scrollTop() + headerOffset,
				stickyPanelOffset = topOffset - $main.offset().top;

				$main.addClass(modifierСlasses.stickyWrapper);
				$stickyPanel.width(stickyPanelWidth);

				if ($main.offset().top <= topOffset && $main.outerHeight() > stickyPanelOffset + $stickyPanel.outerHeight()) {
					$stickyPanel.removeClass(modifierСlasses.sticky.bottom).addClass(modifierСlasses.sticky.top).css({top: stickyPanelOffset + 'px'});
				} else if ($main.offset().top <= topOffset && $main.outerHeight() <= stickyPanelOffset + $stickyPanel.outerHeight()) {
					$stickyPanel.css({top: ''}).removeClass(modifierСlasses.sticky.top).addClass(modifierСlasses.sticky.bottom);
				} else {
					$stickyPanel.removeClass(modifierСlasses.sticky.top);
					$stickyPanel.removeClass(modifierСlasses.sticky.bottom);
				}
			}
		}
	}

	$(document).ready(function () {
		stickyPanel();
	});

	$(window).scroll(function () {
		stickyPanel();
	});

	$(window).resize(function () {
		stickyPanel();
	});
}

export default content;




// WEBPACK FOOTER //
// ./app/blocks/content/content.js